import React, { useState } from "react";
import Layout from "./Layout";

const ContactUs = () => {

  const apiUrl = process.env.REACT_APP_API_URL;

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const [status, setStatus] = useState("");
  const [alertType, setAlertType] = useState(""); // To track Bootstrap alert type

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      console.log("form data :- ", formData);
      const response = await fetch(`${apiUrl}/send-email`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setAlertType("success"); // Set Bootstrap alert type to success
        setStatus("Email sent successfully!");
        setFormData({
          name: "",
          email: "",
          subject: "",
          message: "",
        });
      } else {
        setAlertType("danger"); // Set Bootstrap alert type to danger
        setStatus("There was an error. Please try again.");
      }
    } catch (error) {
      setAlertType("danger"); // Set Bootstrap alert type to danger
      setStatus("There was an error. Please try again. " + error.message);
    }
  };

  return (
    <Layout title="Contact Us" path="contact-us">
      <section className="section-padding section-bg">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-12 col-12 d-flex justify-content-center">
              <h3 className="mb-4 pb-2">We'd love to hear from you</h3>
            </div>

            <div className="col-lg-6 col-12">
              <form
                onSubmit={handleSubmit}
                className="custom-form contact-form"
                role="form"
              >
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-12">
                    <div className="form-floating">
                      <input
                        type="text"
                        name="name"
                        id="name"
                        className="form-control"
                        placeholder="Name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                      />
                      <label htmlFor="name">Name</label>
                    </div>
                  </div>

                  <div className="col-lg-6 col-md-6 col-12">
                    <div className="form-floating">
                      <input
                        type="email"
                        name="email"
                        id="email"
                        pattern="[^ @]*@[^ @]*"
                        className="form-control"
                        placeholder="Email address"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                      <label htmlFor="email">Email address</label>
                    </div>
                  </div>

                  <div className="col-lg-12 col-12">
                    <div className="form-floating">
                      <input
                        type="text"
                        name="subject"
                        id="subject"
                        className="form-control"
                        placeholder="Subject"
                        value={formData.subject}
                        onChange={handleChange}
                        required
                      />
                      <label htmlFor="subject">Subject</label>
                    </div>

                    <div className="form-floating">
                      <textarea
                        className="form-control"
                        id="message"
                        name="message"
                        placeholder="Tell me"
                        value={formData.message}
                        onChange={handleChange}
                        required
                      ></textarea>
                      <label htmlFor="message">Tell me</label>
                    </div>
                  </div>

                  <div className="col-lg-4 col-12 ms-auto">
                    <button type="submit" className="form-control">
                      Submit
                    </button>
                  </div>
                </div>
              </form>

              {/* Display status message with Bootstrap alert */}
              {status && (
                <div className={`alert alert-${alertType} mt-4`} role="alert">
                  {status}
                </div>
              )}
            </div>
            {/* <div className="col-lg-5 col-12 mx-auto mt-5 mt-lg-0">
              <iframe
                className="google-map"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3627.9065465792137!2d73.70540767939073!3d24.592421221651104!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3967e599ed7977eb%3A0x9d879185e3c1067f!2sShubh%20Aashiyana%20apartment!5e0!3m2!1sen!2sin!4v1732275309175!5m2!1sen!2sin"
                width="100%"
                height="250"
                style={{ border: "0" }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>

              <h5 className="mt-4 mb-2">Calcu Technologies LLC</h5>

              <p>
                G-02, Shubh Aashiyana apartment, ShobhagPura Road, Udaipur
                313011, Rajasthan, India
              </p>
            </div> */}
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default ContactUs;
